import { Link } from 'react-router-dom';
import { FooterLink } from '../../../types.ts';
import { Icon, Text, FlexContainer } from '../../../../../../../../ui/index.ts';

export function RenderLink({ icon, id, link, text }: FooterLink) {
  return (
    <Link to={link} target="_blank" key={id} style={{ textDecoration: 'none' }}>
      <FlexContainer alignItems="center" gap="16">
        <Icon glyph={icon} size={50} color="red" />
        <Text
          text={text}
          family="secondary"
          size={30}
          color="red"
          weight="Bold"
          align="center"
          style={{ textDecoration: 'none' }}
        />
      </FlexContainer>
    </Link>
  );
}
